/** ฟอร์มส่วนบน — ไม่รวมคู่ยี่ห้อ/รุ่น (ใช้คู่กับ FORM_PRODUCT_MOBILE_PAIR ต่อแถว) */
export const FORM_PRODUCT_DATA_BASE = ({ channelBuyList }) => {
  return [
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์ (Mobile phone number)',
      type: 'INPUT_PHONE',
      rules: {
        required: true,
        pattern: /^[0-9]{10}$/,
      },
      maxLength: 10,
      disabled: true,
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล (Name - Surname)',
      type: 'INPUT',
      rules: {
        required: true,
      },
    },

    {
      name: 'productId',
      type: 'HIDDEN',
    },

    {
      name: 'barcodeShortcut',
      label: 'รหัสบาร์โค้ด',
      type: 'INPUT_BARCODE_DISPLAY',
      rules: {
        required: true,
        pattern: /^[0-9]{9}$/,
      },
      maxLength: 9,
      disabled: true,
      style: { textAlign: 'center' },
      inputStyle: { textAlign: 'center' },
    },
    {
      name: 'productNameTh',
      label: 'ชื่อสินค้า',
      type: 'INPUT',
      disabled: true,
    },
    {
      name: 'productTypeName',
      label: 'ประเภทสินค้า',
      type: 'INPUT',
      rules: {
        required: true,
      },
      disabled: true,
    },
    {
      name: 'channelBuyId',
      label: 'ซื้อผ่านช่องทาง (Purchase channel)',
      type: 'DROPDOWN',
      properties: {
        options: channelBuyList || [],
      },
      rules: {
        required: true,
      },
    },
  ];
};

/** คู่ยี่ห้อ + รุ่น หนึ่งแถว — index สอดคล้อง useFieldArray name `mobiles` */
export const FORM_PRODUCT_MOBILE_PAIR = ({ mobileBrandList, index }) => {
  const n = index + 1;
  return [
    {
      name: `mobiles.${index}.mobileBrandId`,
      label: n === 1 ? 'ยี่ห้อ (Brand)' : `ยี่ห้อ (Brand) — รายการที่ ${n}`,
      type: 'DROPDOWN',
      properties: {
        options: mobileBrandList || [],
      },
      rules: {
        required: true,
      },
    },
    {
      name: `mobiles.${index}.mobileModelName`,
      label: n === 1 ? 'รุ่น (Model)' : `รุ่น (Model) — รายการที่ ${n}`,
      type: 'INPUT',
      rules: {
        required: true,
      },
    },
  ];
};

/** @deprecated ใช้ FORM_PRODUCT_DATA_BASE + FORM_PRODUCT_MOBILE_PAIR แทน */
export const FORM_PRODUCT_DATA = ({ mobileBrandList, channelBuyList }) => {
  return [...FORM_PRODUCT_DATA_BASE({ channelBuyList }), ...FORM_PRODUCT_MOBILE_PAIR({ mobileBrandList, index: 0 })];
};
export const FORM_SHOW_IMAGE_WARRANTY = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'packageImage',
      label: 'ภาพสินค้า (.png, .jpg, .jpeg, .heic) ',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาถ่ายภาพหรือเลือกภาพสินค้า',
        },
      },
      accept: accept.join(','),
    },
  ];
};
export const FORM_PIC = () => {
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/heic'];
  return [
    {
      name: 'invImage',
      label: 'รูปภาพใบเสร็จ (.png, .jpg, .jpeg, .heic)',
      type: 'UPLOAD_TWO',
      span: 12,
      rules: {
        required: {
          value: true,
          message: 'กรุณาแนบรูปภาพใบเสร็จ',
        },
      },
      accept: accept.join(','),
      maxCount: 1,
    },
  ];
};
